export const COOKIE_NAME = 'cookie-consent';

export enum CookieConsentType {
  NONE = 'none',
  ALL = 'all',
  REQUIRED = 'required',
}
